var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.videosList.length)?_c('section',{staticClass:"my-16 px-4 max-w-screen-4xl mx-auto"},[_c('h2',[_vm._v("Recomendado")]),_c('VideosList',[_vm._v(" En estos momentos no hay ningún vídeo destacado. ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }